module.exports = __webpack_public_path__ + "static/media/ancient_temple.a3b7c6b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/assets/game_icons/ancient_temple.png
// module id = 292
// module chunks = 0